<app-topbar />
<app-mobile-header />
<main class="min-h-screen pb-24 md:pb-0">
  <router-outlet />
</main>
<app-footer class="hidden md:block" />
<app-mobile-nav />
<app-ios-install-banner />
<app-cookie-consent-banner />
